import * as React from 'react';
import { Alert, Box, Button, Card, Checkbox, Grid, Input, Link, Stack, Table, Textarea, Typography, } from "@mui/joy";
import { useDispatch, useSelector } from "react-redux";
import { setAttr, setFormAttr, setServidor, triggerAtualizaDadosBuffer, triggerAtualizarDados, triggerFirstLoad, triggerSendRPCCall } from '../rpc/RPCSlice';
import DisponibilidadeIcon from '../core/components/DisponibilidadeIcon';

import { BarPlot } from '@mui/x-charts/BarChart';
import { AreaPlot, LinePlot } from '@mui/x-charts/LineChart';
import { ChartContainer } from '@mui/x-charts/ChartContainer';
import { ChartsXAxis } from '@mui/x-charts/ChartsXAxis';
import { ChartsYAxis } from '@mui/x-charts/ChartsYAxis';
import { formatDateJavaComHoras, formataTimeDeMilli, formataTamahoDeBytes } from '../helper/functions';
import { displayGeneralDetail } from '../helper/general-details/GeneralDetailSlice';
import LoadingTag from '../core/components/LoadingTag';


function RPCDashboard() {

    var dispatch = useDispatch()
    var loading = useSelector((state) => state.rpc.loading)
    var buffer = useSelector((state) => state.rpc.buffer)
    var rs = useSelector((state) => state.rpc.resultadosPreparados)
    var calls = useSelector((state) => state.rpc.callsFormatted)
    var servidor = useSelector((state) => state.rpc.servidorUrl)
    var form = useSelector((state) => state.rpc.form)
    var silentLoading = useSelector((state) => state.rpc.silentLoading)
    var page = useSelector((state) => state.rpc.page)
    var resultsPerPage = 30

    var requests = []
    var errors = []
    var times = []
    var datas = []

    if (rs != null) {
        requests = rs.requests
        errors = rs.errors
        times = rs.time
        datas = rs.datas
    }
    var series = [
        {
            type: 'bar',
            stack: '',
            yAxisKey: 'requests',
            color: "#3FB0D2",
            data: requests //...rs.map(r => r.requests)
        },
        {
            type: 'line',
            yAxisKey: 'requests',
            color: '#f78787',
            data: errors, //...rs.map(r => r.errors)
            area: true,
        },]

    var otherSeries = [
        {
            type: 'line',
            yAxisKey: 'time',
            color: '#f78787',
            data: times, //...rs.map(r => r.time)
            area: true,
        },
    ]

    var atualizar = () => {
        dispatch(triggerAtualizarDados())
        dispatch(triggerAtualizaDadosBuffer())
    }

    var enviar = () => {
        dispatch(triggerSendRPCCall())
    }

    React.useEffect(() => {
        dispatch(triggerFirstLoad())
    }, []);

    if (loading)
        return <Grid container sx={{ padding: "10px" }}>
            <Loading />
        </Grid>

    return <Grid container sx={{ padding: "10px" }}>
        <Grid xs={12}>
            <Button color="primary" onClick={atualizar} disabled={silentLoading}>
                {silentLoading ? "Atualizando..." : "Atualizar"}
            </Button>
        </Grid>
        <Grid xs={12}>
            <Stack>
                <Typography>Buffer</Typography>
                <Typography>CallsParaIniciar: {buffer.callsParaIniciar}</Typography>
                <Typography>CallsParaConcluir: {buffer.callsParaConcluir}</Typography>
            </Stack>
        </Grid>
        <Grid xs={6}>
            <ChartContainer
                series={series}
                width={480}
                height={300}
                xAxis={[
                    {
                        id: 'years',
                        data: datas,
                        scaleType: 'band',
                        valueFormatter: (value) => value.toString(),
                    },
                ]}
                yAxis={[
                    {
                        id: 'requests',
                        scaleType: 'linear',
                    },
                    {
                        id: 'errors',
                        scaleType: 'linear',
                    },
                ]}
            >
                <BarPlot />
                <LinePlot />
                <ChartsXAxis label="" position="bottom" axisId="years" />
                <ChartsYAxis label="Requests" position="left" axisId="requests" />
                <ChartsYAxis label="Errors" position="right" axisId="errors" />
            </ChartContainer>
        </Grid>
        <Grid xs={6}>

            <ChartContainer
                series={otherSeries}
                width={480}
                height={300}
                xAxis={[
                    {
                        id: 'years',
                        data: datas,
                        scaleType: 'band',
                        valueFormatter: (value) => value.toString(),
                    },
                ]}
                yAxis={[
                    {
                        id: 'time',
                        scaleType: 'linear',
                    },
                ]}
            >
                <AreaPlot />
                <ChartsXAxis label="" position="bottom" axisId="years" />
                <ChartsYAxis label="Time" position="right" axisId="time" />
            </ChartContainer>
        </Grid>
        <Grid xs={12} sx={{ paddingBottom: "10px" }}>
            <Card>
                <Button color="primary" onClick={() => {
                    dispatch(setFormAttr({
                        campo: "hide",
                        valor: !form.hide
                    }))
                }}>Toggle hide</Button>
                {!form.hide &&
                    <Stack spacing={1}>
                        {form.response != null && <div><pre>{JSON.stringify(form.response, null, 2)}</pre></div>}
                        {form.error.trim().length > 0 && <Alert variant='soft' color="danger">{form.error}</Alert>}
                        <Input type='text' placeholder="Servidor..." value={servidor} onChange={
                            (e) => {
                                dispatch(setServidor(e.target.value))
                            }
                        }></Input>
                        <Input type='text' placeholder='Action...' value={form.action} onChange={(e) => {
                            dispatch(setFormAttr({
                                campo: "action",
                                valor: (e.target.value).toUpperCase().replace(" ", "_")
                            }))
                        }}></Input>
                        <Box sx={{ verticalAlign: "center" }}>
                            <Checkbox label='runNow' checked={form.runNow} onChange={e => {
                                dispatch(setFormAttr({
                                    campo: "runNow",
                                    valor: !form.runNow
                                }))
                            }} />
                        </Box>
                        <Input type='file' onChange={(e) => {
                            dispatch(setFormAttr({
                                campo: "file",
                                valor: e.target.files[0]
                            }))
                        }}></Input>
                        <Textarea minRows={10} value={form.payload == null ? "" : form.payload} onChange={(e) => {
                            dispatch(setFormAttr({
                                campo: "payload",
                                valor: (e.target.value)
                            }))
                        }}></Textarea>
                        <Box>
                            <Stack direction={"row"} spacing={1}>
                                <Button color="primary" onClick={enviar} disabled={silentLoading}> Enviar </Button>
                                <Button color="primary" onClick={atualizar} disabled={silentLoading}>
                                    {silentLoading ? "Atualizando..." : "Atualizar"}
                                </Button>
                            </Stack>
                        </Box>
                    </Stack>}
            </Card>
        </Grid>
        <Grid xs={12}>
            <Stack direction={"row"} spacing={1}>
                <Button size='sm' onClick={() => {
                    dispatch(setAttr({
                        campo: "page",
                        valor: 0
                    }))
                }}> &lt;&lt; </Button>
                <Button size='sm' onClick={() => {
                    dispatch(setAttr({
                        campo: "page",
                        valor: page - 1
                    }))
                }}> Previous </Button>
                <Typography>Page: {page} / {Math.floor(calls.length / resultsPerPage)}</Typography>
                <Button size="sm" onClick={() => {
                    dispatch(setAttr({
                        campo: "page",
                        valor: page + 1
                    }))
                }}> Next </Button>
                <Button size='sm' onClick={() => {
                    dispatch(setAttr({
                        campo: "page",
                        valor: Math.floor(calls.length / resultsPerPage)
                    }))
                }}> &gt;&gt; </Button>
            </Stack>
        </Grid>
        <Grid xs={12}>

            <Table size="small" aria-label="striped table" stripe={"odd"}>
                <thead>
                    <tr>
                        <th style={{ width: "3%" }}>ID</th>
                        <th style={{ width: "13%" }}>Date</th>
                        <th style={{ width: "10.5%" }}>N/S/F/Su</th>
                        <th style={{ width: "36%" }}>Action</th>
                        <th style={{ width: "10%" }}>Json/File</th>
                        <th style={{ width: "6%" }}>Time</th>
                        <th>Error</th>
                    </tr>
                </thead>
                <tbody>
                    {calls.slice(page * resultsPerPage, (page * resultsPerPage) + resultsPerPage).map(c => {
                        return <tr key={c.id}>
                            <td><Link onClick={() => dispatch(displayGeneralDetail(c.id))
                            }>{"ID"}</Link></td>
                            <td>{c.formatted.receivedDate}</td>
                            <td>
                                <Stack direction={"row"}>
                                    <DisponibilidadeIcon disp={c.runNow} />
                                    <DisponibilidadeIcon disp={c.startDate != null} />
                                    <DisponibilidadeIcon disp={c.finishDate != null} />
                                    <DisponibilidadeIcon disp={c.success} />
                                </Stack>

                            </td>
                            <td>{c.action}</td>
                            <td>{c.formatted.jsonLength}/{c.formatted.fileLength}</td>
                            <td>{c.formatted.executionTime}</td>
                            <td style={{
                                textOverflow: "ellipsis",
                                overflow: "hidden",
                                whiteSpace: "nowrap"
                            }}>{c.error != null && <Link onClick={() => dispatch(displayGeneralDetail(c.error))
                            }>{c.error}</Link>}</td>
                        </tr>
                    })}
                </tbody>
            </Table>
        </Grid>
    </Grid>
}

function Loading() {
    return <LoadingTag loading={true} />
}

export default RPCDashboard;